"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { Button } from "../ui/button";
import { Typography } from "../ui/typography";
import LocationTagsSection from "./LocationTagsSection";
import { ArrowLeft01FreeIcons } from "@hugeicons/core-free-icons";

const ReserveSection = () => {
  return (
    <div className="space-y-4 px-5 md:px-0">
      <Typography variant="h4Bold">رزرو اقامتگاه</Typography>
      <Typography variant="bodyMRegular">
        اگر راهی سفر هستید و می‌خواهید برای آن برنامه‌ریزی کنید، احتمالا یکی از
        اولین اقداماتی که انجام می‌دهید جستجوی اقامتگاه است. شاید به‌دنبال یک
        اقامتگاه کوچک هستید که مناسب اسکان یک نفر باشد یا شاید هم می‌خواهید
        گروهی سفر کنید و به‌دنبال یک اقامتگاه بسیار بزرگ هستید؛ اقامتگاهی که
        تمام امکانات رفاهی را برای تجربه لوکس مسافرانش فراهم کرده باشد ....
      </Typography>
      <div className="flex flex-col md:flex-col-reverse gap-2.5">
        <LocationTagsSection />
        <Button
          variant="link"
          className="text-black-200 text-sm self-start !px-0"
        >
          بیشتر
          <HugeiconsIcon
            icon={ArrowLeft01FreeIcons}
            size={20}
            className="size-5"
            strokeWidth={1.5}
          />
        </Button>
      </div>
    </div>
  );
};

export default ReserveSection;
